import { useNavigate } from 'react-router-dom';

import './cabinet-sessions.scss';

import { routerKeys } from '~shared/router';
import { Preloader } from '~shared/ui';

import { SessionItem } from './SessionItem.tsx';
import { useListSessions } from './use-list-sessions.ts';

export function SessionList() {
	const { pending, list } = useListSessions();
	const navigate = useNavigate();

	const handleEndSession = (id: number) => {
		navigate(routerKeys.manager.end(id.toString()));
	};

	return (
		<div className="cabinet-sessions">
			<div className="table-overlay">
				<table className="table">
					<thead>
						<tr>
							<th>Начало смены</th>
							<th>Сотрудник</th>
						</tr>
					</thead>
					<tbody>
						{pending ? (
							<tr>
								<td colSpan={2} align="center">
									<Preloader />
								</td>
							</tr>
						) : (
							<>
								{list.map(itm => (
									<SessionItem key={itm.id} journal={itm} onEnd={handleEndSession} />
								))}
							</>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}
